import isEqual from "lodash/isEqual";
import { reduceById } from "redux-store/reducers";

import { LOAD_DEVICE_EVENTS_SUCCESS, UNLOAD_DEVICE_EVENTS } from "./actions";

const initialState = {};

function concatEventsReducer(state, action) {
  const { payload } = action;
  const { serviceArgs, data: events } = payload;
  const [deviceId] = serviceArgs;
  const newEvents = reduceById({}, events);

  let newState;
  if (deviceId === state.deviceId) {
    newState = {
      ...state,
      events: {
        ...state.events,
        ...newEvents,
      },
    };
  } else {
    newState = {
      ...state,
      deviceId,
      events: {
        ...newEvents,
      },
    };
  }

  return isEqual(state, newState) ? state : newState;
}

function deviceEventsReducer(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case LOAD_DEVICE_EVENTS_SUCCESS:
      return concatEventsReducer(state, action);
    case UNLOAD_DEVICE_EVENTS:
      return initialState;
    default:
      return state;
  }
}

export { deviceEventsReducer };
